export default {"src":"/_next/static/media/peaceOfMind_40.5cf1e01c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};